module.exports = __webpack_public_path__ + "img/special-collab-uned.249f93dc.png";